module.exports = __webpack_public_path__ + "static/media/delete.44807b87.ico";